export const safeJsonParse = (value: any) => {
  try {
    // Check if the input is already a JSON object
    if (typeof value === 'object') {
      return value;
    }
    
    // Check if the input is a stringified JSON object or array
    if (
      typeof value === 'string' &&
      (value.trim().startsWith('{') && value.trim().endsWith('}') || value.trim().startsWith('[') && value.trim().endsWith(']'))
    ) {
      const jsonValue: any = JSON.parse(value);
      return jsonValue;
    }

    // If neither JSON object nor stringified JSON, return the value itself
    return value;
  } catch {
    return undefined;
  }
};
